import { render, staticRenderFns } from "./marcarFacturacionModal.vue?vue&type=template&id=1ddb9da6&"
import script from "./marcarFacturacionModal.vue?vue&type=script&lang=js&"
export * from "./marcarFacturacionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QIcon,QSelect,QBtn,QTooltip,QMarkupTable,QTr,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QIcon,QSelect,QBtn,QTooltip,QMarkupTable,QTr,QTd})
